class StickyProductForm extends HTMLElement {
  constructor() {
    super();

    this.addToCartButton = document.querySelector('[id^="ProductSubmitButton-"]');
    this.footerGroup = document.querySelector('.content-for-footer');
  }

  observer = undefined;

  connectedCallback() {
    if (!this.addToCartButton || !this.footerGroup) {
      return;
    }

    // If addToCartButton is not visible AND footerGroup is not visible, then add sticky-product-form--show class to StickyProductForm.
    // If addToCartButton is visible OR footerGroup is visible, then remove sticky-product-form--show class from StickyProductForm.
    let isAddToCartButtonVisible = false;
    let isFooterGroupVisible = false;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === this.addToCartButton) {
          isAddToCartButtonVisible = entry.isIntersecting;
          console.log('isAddToCartButtonVisible', isAddToCartButtonVisible);
        }

        if (entry.target === this.footerGroup) {
          isFooterGroupVisible = entry.isIntersecting;
          console.log('isFooterGroupVisible', isFooterGroupVisible);
        }
      });

      console.log(isAddToCartButtonVisible, isFooterGroupVisible);
      if (!isAddToCartButtonVisible && !isFooterGroupVisible) {
        this.classList.add('sticky-product-form--show');
      } else {
        this.classList.remove('sticky-product-form--show');
      }
    });

    this.observer.observe(this.addToCartButton);
    this.observer.observe(this.footerGroup);
  }
}

customElements.define('sticky-product-form', StickyProductForm);
